import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  Grid,
  Box,
  Paper,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { BigHeadline } from "../../../../components/TextParts";
import BaseApi from "../../../../functions/axios";
import ChangeUserInfoButton from "../molecules/ChangeUserInfoButton";
import NonIconButton from "../../../../components/NonIconButton";
import { useLocalStorage } from "../../../../hooks/localStrage";
import "../../../../style/disabledRadioButton.css";

const schema = yup.object({
  name: yup
    .string()
    .required("名前を入力してください")
    .min(2, "正しい名前を入力してください"),
});

export default function ChangeUserInfoForm() {
  const [, setAdminFlag] = useLocalStorage("adminFlag");
  const [, setMailNotificationToLS] = useLocalStorage("mailNotification");
  const [, setCurrentPage] = useLocalStorage("currentPage");

  const [mailNotification, setMailNotification] = useState(() =>
    Number(localStorage.getItem("mailNotification"))
  );
  const [userClass, setUserClass] = useState(() =>
    Number(localStorage.getItem("adminFlag"))
  );

  const [data, setData] = useState(null);
  const [nameCheck, setNameCheck] = useState("");
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const userId = localStorage.getItem("userId");

  useEffect(() => {
    BaseApi.get("user", { params: { user_id: userId } }).then((result) => {
      const userData = result.data.data;
      setData(userData);
      setNameCheck(userData.name);
      setValue("name", userData.name);
    });
  }, [userId, setValue]);

  if (!data) return null;

  const handleChangeMailNotification = (e) => {
    setMailNotification(Number(e.target.value));
  };

  const handleChangeUserClass = (e) => {
    setUserClass(Number(e.target.value));
  };

  const handleOnNameChange = (e) => {
    setNameCheck(e.target.value);
  };

  const onSubmit = (event) => {
    const postData = {
      user_id: userId,
      name: event.name,
      admin_flag: userClass,
      notification_flag: mailNotification,
    };

    BaseApi.post("update_user", postData).then(() => {
      setCurrentPage(process.env.REACT_APP_DASHBOARD_NUM);
      setMailNotificationToLS(mailNotification);
      setAdminFlag(userClass);
      navigate("/dashboard");
    });
  };

  const bpManagementClass = Number(process.env.REACT_APP_BP_MANAGEMENT_CLASS);
  const generalClass = Number(process.env.REACT_APP_GENERAL_CLASS);

  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
      <BigHeadline text="ユーザ情報変更" />
      <Paper elevation={0}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ borderBottom: 1, borderColor: "#F2F3F4" }}
        >
          <Grid
            item
            xs={4}
            sm={2.5}
            sx={{ fontWeight: "bold", p: "20px", pl: "20px" }}
          >
            氏名
          </Grid>
          <Grid item xs={8} sm={9.5} sx={{ p: "20px", pl: "15px" }}>
            <TextField
              variant="standard"
              required
              {...register("name")}
              error={Boolean(errors.name)}
              helperText={errors.name?.message}
              fullWidth
              id="name"
              InputProps={{
                disableUnderline: true,
                style: { fontSize: 16 },
              }}
              onChange={(e) => {
                register("name").onChange(e);
                handleOnNameChange(e);
              }}
            />
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ borderBottom: 1, borderColor: "#F2F3F4" }}
        >
          <Grid
            item
            xs={4}
            sm={2.5}
            sx={{ fontWeight: "bold", p: "20px", pl: "20px" }}
          >
            メールアドレス
          </Grid>
          <Grid
            item
            xs={8}
            sm={9.5}
            sx={{ py: "20px", pl: "15px", fontSize: 16 }}
          >
            {data.email}
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ borderBottom: 1, borderColor: "#F2F3F4" }}
        >
          <Grid
            item
            xs={4}
            sm={2.5}
            sx={{ fontWeight: "bold", p: "20px", pl: "20px" }}
          >
            ユーザ区分
          </Grid>
          <Grid
            item
            xs={8}
            sm={9.5}
            sx={{ my: "20px", fontSize: 16, pl: "15px" }}
          >
            <RadioGroup
              value={userClass}
              row
              onChange={handleChangeUserClass}
            >
              <FormControlLabel
                value={bpManagementClass}
                label={
                  <Typography fontSize={16} color="#808080">
                    BP管理者
                  </Typography>
                }
                control={
                  <Radio
                    disabled
                    size="small"
                    sx={{
                      color: "#808080",
                      "&.Mui-checked": { color: "#28345E" },
                    }}
                  />
                }
              />
              <FormControlLabel
                value={generalClass}
                label={<Typography fontSize={16}>一般ユーザ</Typography>}
                control={
                  <Radio
                    size="small"
                    sx={{ "&.Mui-checked": { color: "#28345E" } }}
                  />
                }
              />
            </RadioGroup>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ borderBottom: 1, borderColor: "#F2F3F4" }}
        >
          <Grid
            item
            xs={4}
            sm={2.5}
            sx={{ fontWeight: "bold", p: "20px", pl: "20px" }}
          >
            新着マッチング
          </Grid>
          <Grid
            item
            xs={8}
            sm={9.5}
            sx={{ my: "20px", fontSize: 16, pl: "15px" }}
          >
            <RadioGroup
              value={mailNotification}
              row
              onChange={handleChangeMailNotification}
            >
              <FormControlLabel
                value={1}
                label={<Typography fontSize={16}>通知する</Typography>}
                control={
                  <Radio
                    size="small"
                    sx={{ "&.Mui-checked": { color: "#28345E" } }}
                  />
                }
              />
              <FormControlLabel
                value={0}
                label={<Typography fontSize={16}>通知しない</Typography>}
                control={
                  <Radio
                    size="small"
                    sx={{ "&.Mui-checked": { color: "#28345E" } }}
                  />
                }
              />
            </RadioGroup>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ borderBottom: 1, borderColor: "#F2F3F4" }}
        >
          <Grid
            item
            xs={4}
            sm={2.5}
            sx={{ fontWeight: "bold", p: "20px", pl: "20px" }}
          >
            パスワード
          </Grid>
          <Grid
            item
            xs={8}
            sm={9.5}
            sx={{
              mt: "20px",
              mb: "15px",
              fontSize: 16,
              display: "flex",
              pl: "15px",
            }}
          >
            ＊＊＊＊＊＊＊＊
            <Box sx={{ width: "150px", mr: "40px", ml: "auto" }}>
              <NonIconButton
                title="変更"
                clickEvent={() => navigate("/editPassword")}
              />
            </Box>
          </Grid>
        </Grid>
      </Paper>

      <ChangeUserInfoButton
        mailNotification={mailNotification}
        userClass={userClass}
        nameCheck={nameCheck}
        data={data}
      />
    </Box>
  );
}